import { get } from 'src/helpers/request-helper';
import type { ClubLocation } from 'src/models/club-location';
import type { AwayClubAccess } from 'src/models/responses/away-club-access';

type ClubLocations = Record<string, ClubLocation>;

export const getClubLocations = (): Promise<ClubLocations> => {
  return get<{ clubLocations: ClubLocations }>('clubs/locations').then(
    (clubLocationsResponse) => clubLocationsResponse.clubLocations
  );
};

export const getAwayClubsAccess = (clubId: string): Promise<AwayClubAccess> => {
  return get<AwayClubAccess>(`clubs/${clubId}/away-clubs`).then((awayClubAccessResponse) => ({
    clubsInTheSameTierOrLower: awayClubAccessResponse.clubsInTheSameTierOrLower,
    clubsInAHigherTier: awayClubAccessResponse.clubsInAHigherTier,
    clubsInAnExclusiveTier: awayClubAccessResponse.clubsInAnExclusiveTier,
  }));
};
